import { R as React } from './injectIntl-6b03af4d.js';

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

const TransitionGroupContext = React.createContext(null);

export { TransitionGroupContext as T, _inheritsLoose as _ };

//# sourceMappingURL=TransitionGroupContext-69a268e3.js.map